var _path, _setting;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "#272731",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69572 37.2637C5.25592 37.658 5.00464 38.2208 5.00464 38.8115V77.8048C5.00464 78.9529 5.93537 79.8837 7.08347 79.8837L34.1521 79.8837V59.0641C34.1521 54.4647 37.8807 50.7362 42.48 50.7362C47.0794 50.7362 50.8079 54.4647 50.8079 59.0641V79.8837L77.8766 79.8837C79.0247 79.8837 79.9554 78.9529 79.9554 77.8048V38.8115C79.9554 38.2208 79.7041 37.658 79.2643 37.2637L43.8678 5.52731C43.0781 4.81927 41.882 4.81927 41.0923 5.52731L5.69572 37.2637Z",
    stroke: "white",
    strokeWidth: 8,
    strokeDasharray: "308.07403564453125,0,0,0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    from: "0,0,0,308.07403564453125",
    to: "308.07403564453125,0,0,0",
    dur: "1.8518518518518519s",
    begin: "mouseover",
    fill: "freeze"
  }))), _setting || (_setting = /*#__PURE__*/React.createElement("setting", null, "{\"type\":\"direct\",\"speed\":27,\"random\":1,\"shift\":1,\"size\":1,\"rupture\":50}")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.264b3a47eb272e6703daf90763299d42.svg";
export { ForwardRef as ReactComponent };